<template>
    <div class="page_title_area">
        运营帐号
    </div>
</template>

<script>
import mixins from "./Mixins";
export default {
mixins:[mixins],
mounted(){
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(3);
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/PartI/OperationAccount/components/accountTitle.vue